import { useNavigate } from "react-router-dom";
import { CircleHelp } from "lucide-react";
import { useProgressoAjuda } from "@/core/hooks/useProgressoAjuda";
import { LICOES_BASE } from "@/core/ajuda/licoes";
import { deveMostrarCartao } from "@/core/ajuda/progresso";

/**
 * Cartão "Novo por aqui?" do Início (aprovado pelo usuário em 15/10/2026 —
 * regra do Início: item novo nesta tela só com aprovação). Só convida; fecha
 * com "Agora não" e nunca bloqueia nada. Some sozinho quando a pessoa já viu
 * as lições para todos (conhecendo, avisos e atividades). As lições de quem lidera ou gerencia um
 * elo não contam aqui: elas têm cartão próprio (ConviteAjudaPapel). A Ajuda continua no menu da conta.
 */
export function ConviteAjudaInicio() {
  const navigate = useNavigate();
  const { progresso, pronto, dispensarConvite } = useProgressoAjuda();
  const ids = [...LICOES_BASE];

  if (!pronto || !deveMostrarCartao(progresso, ids)) return null;

  const jaComecou = progresso.vistas.length > 0;

  return (
    <section
      aria-label="Ajuda do Elos"
      className="mb-6 flex flex-col gap-4 rounded-2xl border border-primary/40 bg-primary/5 p-4 sm:flex-row sm:items-center sm:p-5"
    >
      <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-primary/10 text-primary">
        <CircleHelp size={22} aria-hidden="true" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-base font-bold text-text">Novo por aqui?</p>
        <p className="text-sm text-muted">
          {jaComecou
            ? "Continue de onde parou na Ajuda do Elos."
            : `Conheça o Elos em ${ids.length} lições curtas.`}
        </p>
      </div>
      <div className="flex shrink-0 gap-2">
        <button
          type="button"
          onClick={() => navigate(jaComecou ? "/ajuda" : "/ajuda/apresentacao")}
          className="min-h-11 rounded-lg bg-primary px-4 text-sm font-bold text-on-primary transition-colors hover:bg-primary-hover"
        >
          {jaComecou ? "Continuar" : "Começar"}
        </button>
        <button
          type="button"
          onClick={dispensarConvite}
          className="min-h-11 rounded-lg border border-border bg-surface px-4 text-sm font-bold text-muted transition-colors hover:bg-surface-2 hover:text-text"
        >
          Agora não
        </button>
      </div>
    </section>
  );
}
